var moment = require('moment');
import _ from 'lodash'

import util from '../util.js';

/**
 * getters get data from state
 * @module getters
 */
export default {
    events(state) {
        return state.events;
    },

    currentEvent(state) {
        return state.currentSingleEvent;
    },

    divisionalInformation(state) {
        return state.divisionalInformation
    },

    currentStudyProgramme(state) {
        return state.currentStudyProgramme
    },

    dateOrderEvents(state) {
        return state.dateOrderEvents;
    },

    nameOrderEvents(state) {
        return state.nameOrderEvents;
    },

    modules(state) {
        return state.modules;
    },

    moduleIntervalTree(state) {
        return state.moduleIntervalTree;
    },

    dateModules(state) {
        return state.dateModules;
    },

    moduleDayDateOrder(state) {
        return state.moduleDayDateOrder;
    },

    dateFormat(state) {
        return state.dateFormat;
    },

    timeFormat(state) {
        return state.timeFormat;
    },

    selectedModules(state) {
        return state.selectedModules;
    },

    clashingModules(state) {
        return state.clashingModules;
    },

    eventHasLoaded(state, getters) {
        return getters.currentEventId === state.lastLoadedEvent;
    },

    /**
     * gets the first module by start time for the current event
     * @returns {object} the module data for the first module
     */
    firstModule(state) {
        let returnData = {};

        if (
            !util.objectIsEmpty(state.moduleDayDateOrder) &&
            !util.objectIsEmpty(state.dateModules)
        ) {
            let firstDate = state.moduleDayDateOrder[0];
            let firstModule = state.dateModules[firstDate][0];

            returnData = firstModule;
        }

        return returnData;
    },

    /**
     * gets the last module by start time for the current event
     * @returns {object} the module data for the last module
     */
    lastModule(state, getters) {
        let returnData = {};

        if (
            !util.objectIsEmpty(state.moduleDayDateOrder) &&
            !util.objectIsEmpty(state.dateModules) &&
            getters.eventHasLoaded
        ) {
            let lastDate = state.moduleDayDateOrder[state.moduleDayDateOrder.length -1];

            let lastDateModules = state.dateModules[lastDate];

            let lastModule = lastDateModules[lastDateModules.length -1];

            returnData = lastModule;
        }
        return returnData;
    },

    currentEventId(state) {
        return state.currentSingleEvent.id || -1;
    },

    errorWaitTime(state) {
        return state.errorWaitTime;
    },

    registered(state) {
        return state.registered;
    },

    hasRequiredDetails(state) {
        return state.firstname !== "" &&
          state.surname !== "" &&
          state.email !== ""
    },

    locationFromModules(state) {
        let locations =  _(state.modules)
            .mapValues(module => module.location_name)
            .values()
            .value()

        let filtered_locations = locations.filter(function(elem, index, self) {
            return index === self.indexOf(elem);
        })
      
        if (filtered_locations.length > 1) {
            // Display more than 1 location
            return filtered_locations.join(" | ")
        } else if (filtered_locations.length == 1) {
            // Display 1 location
            return locations[0]
        }
    },

}



// WEBPACK FOOTER //
// ./src/store/getters.js